import {mapFields} from "vuex-map-fields";
import {mapGetters} from "vuex";
import {required} from 'vuelidate/lib/validators';
import {Reference} from "smd-vue-scaffold";

import FormRequiredNote from '@/components/common/form-required-note';

import ModalCityList from '@/modals/modal-city-list';
import FormValidationMixin from '@/mixins/form-validations';
import GetElementString from '@/mixins/get-element-string';
import SetActiveStepMixin from '@/mixins/set-active-step-mixin';
import ToastMixin from '@/mixins/toast-mixin';
import MedicineOrderRequestMixin from '@/mixins/services/medicine-order-request-mixin';

import {PHARMACY_ORDERS_DISCOUNT} from '@/reference/pharmacy-order-steps'

import {
  alphaSpaces,
  mobileNumberValid,
} from '@/utils/custom-validations';
import {
  getCityValue,
} from "@/utils";

import {
  GETTER_FILES,
  GETTER_FIRSTNAME,
  GETTER_LASTNAME,
  GETTER_MIDDLENAME,
  GETTER_MOBILENUMBER,
  GETTER_ONGOING_MEDICINE_ORDERS,
} from "@/store/types";

export default {
  mixins: [
    FormValidationMixin,
    GetElementString,
    SetActiveStepMixin,
    ToastMixin,
    MedicineOrderRequestMixin,
  ],
  components: {FormRequiredNote},
  props: {
    desktopView: {type: Boolean, default: false},
  },
  data() {
    return {
      contactPerson: '',
      cityObject: null,
      error: null,
    };
  },
  computed: {
    ...mapGetters({
      serviceOrders: GETTER_ONGOING_MEDICINE_ORDERS,
      storeFirstName: GETTER_FIRSTNAME,
      storeMiddleName: GETTER_MIDDLENAME,
      storeLastName: GETTER_LASTNAME,
      storeMobileNumber: GETTER_MOBILENUMBER,
      files: GETTER_FILES,
    }),
    ...mapFields({
      mobilenumber: 'mobilenumber',
      firstname: 'firstname',
      lastname: 'lastname',
      street: 'deliveryaddress.street',
      city: 'deliveryaddress.city',
      buildingname: 'deliveryaddress.buildingname',
      availmentCode: 'availmentCode',
      attachedPrescriptions: 'attachedPrescriptions',
    }),
    computedCityPlaceholder() {
      return !this.city ? 'txt201' : '';
    },
    computedCityTitle() {
      return this.city ? this.city : '';
    },
    computedVariant() {
      return this.disableSubmit ? 'right-blue-disabled' : 'right-blue-enabled';
    },
    disableSubmit() {
      return this.$v.$invalid;
    },
  },
  watch: {
    attachedPrescriptions: {
      handler(prescriptions) {
        if (prescriptions && prescriptions.length && prescriptions[0].patientname) {
          this.contactPerson = prescriptions[0].patientname;
        } else {
          this.contactPerson = `${this.storeFirstName} ${this.storeLastName}`;
        }
      },
      deep: true,
      immediate: true,
    },
    contactPerson: {
      handler(contactPerson) {
        const splittedName = contactPerson.split(' ');

        if (splittedName.length > 1) {
          this.lastname = splittedName.pop();
          this.firstname = splittedName.join(' ');
        } else {
          this.lastname = '';
          this.firstname = contactPerson;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.mobilenumber = this.storeMobileNumber;
    this.$v.$touch();
  },
  methods: {
    showCityModal() {
      this.$modal.open({
        component: ModalCityList,
        size: this.$isMobile ? Reference.SmdModalSizes.xs : Reference.SmdModalSizes.sm,
        position: !this.$isMobile ? 'detached' : '',
        props: {
          existingSelectedCity: this.cityObject,
        },
        onClose: (cityObject) => {
          this.cityObject = cityObject;
          this.city = getCityValue(cityObject);
        },
      })
    },
    submit() {
      this.submitOrder();
    },
  },
  validations: {
    mobilenumber: {
      required,
      mobileNumberValid: mobileNumberValid('mobilenumber', true),
    },
    contactPerson: {
      required,
      alphaSpaces,
    },
    street: {
      required,
    },
    city: {
      required,
    },
  },
  PHARMACY_ORDERS_DISCOUNT,
}
